import react from 'assets/images/skills/react.png'
import javascript from 'assets/images/skills/javascript.png'
import typescript from 'assets/images/skills/typescript.png'
import python from 'assets/images/skills/python.png'
import css from 'assets/images/skills/css3.png'
import html from 'assets/images/skills/html-5.png'
import node from 'assets/images/skills/node-removebg-preview.png'
import firebase from 'assets/images/skills/firebase-google.png'
import mongodb from 'assets/images/skills/mongodb.png'

export const skills = [
	{
		name: 'Html5',
		link: 'https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5',
		image: html,
	},
	{
		name: 'Css3',
		link: 'https://developer.mozilla.org/en-US/docs/Web/CSS',
		image: css,
	},
	{
		name: 'React',
		link: 'https://reactjs.org/',
		image: react,
	},
	{
		name: 'Python',
		link: 'https://www.python.org/',
		image: python,
	},
	{
		name: 'JS',
		link: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
		image: javascript,
	},
	{
		name: 'TS',
		link: 'https://www.typescriptlang.org/',
		image: typescript,
	},
	{
		name: 'MongoDB',
		link: 'https://www.mongodb.com/',
		image: mongodb,
	},
	{
		name: 'Firebase',
		link: 'https://firebase.google.com/',
		image: firebase,
	},
	{
		name: 'Nodejs',
		link: 'https://nodejs.org/en/',
		image: node,
	},
]
